module.exports = __webpack_public_path__ + "public/SiteImages/whyhostbanner.jpg?01b44601";